import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMyobComponent } from './simple-icons-myob.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMyobComponent ],
    exports:      [ SimpleIconsMyobComponent ],
    bootstrap:    []
})
export class SimpleIconsMyobModule {}
